import { useSyncExternalStore } from "react";

const suscribir = (avisar: () => void) => {
  window.addEventListener("online", avisar);
  window.addEventListener("offline", avisar);
  return () => {
    window.removeEventListener("online", avisar);
    window.removeEventListener("offline", avisar);
  };
};

/**
 * El navegador dice que no hay red. Es la única señal cuando el latido no
 * corre: un equipo sin alta, o cuya cola no abrió, no late (§2.7 de
 * OFFLINE-POS-RONDA-2.md). Donde el latido corre, manda el latido.
 */
export function useSinRedDelNavegador(): boolean {
  return useSyncExternalStore(
    suscribir,
    () => navigator.onLine === false,
    () => false
  );
}
